<template>
  <svg width="17"
       height="20"
       viewBox="0 0 17 20"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.00002 3.75C9.00002 3.33579 8.66423 3 8.25002 3C7.8358 3 7.50002 3.33579 7.50002 3.75V5.35352C6.34576 5.67998 5.50002 6.74122 5.50002 8C5.50002 8.78071 5.82535 9.48544 6.34784 9.98601L5.05366 13.2215C4.89982 13.606 5.08689 14.0425 5.47147 14.1964C5.85606 14.3502 6.29254 14.1631 6.44637 13.7785L7.68134 10.6911C7.86483 10.7297 8.05505 10.75 8.25002 10.75C8.44498 10.75 8.6352 10.7297 8.81869 10.6911L10.0537 13.7785C10.2075 14.1631 10.644 14.3502 11.0286 14.1964C11.4131 14.0425 11.6002 13.606 11.4464 13.2215L10.1522 9.98601C10.6747 9.48544 11 8.78071 11 8C11 6.74122 10.1543 5.67998 9.00002 5.35352V3.75ZM7.00002 8C7.00002 7.30964 7.55966 6.75 8.25002 6.75C8.94037 6.75 9.50002 7.30964 9.50002 8C9.50002 8.69036 8.94037 9.25 8.25002 9.25C7.55966 9.25 7.00002 8.69036 7.00002 8ZM2.5 0C1.11929 0 0 1.11929 0 2.5V17.5C0 18.8807 1.11929 20 2.5 20H15.75C16.1642 20 16.5 19.6642 16.5 19.25C16.5 18.8358 16.1642 18.5 15.75 18.5H2.5C1.94772 18.5 1.5 18.0523 1.5 17.5H15.75C16.1642 17.5 16.5 17.1642 16.5 16.75V2.5C16.5 1.11929 15.3807 0 14 0H2.5ZM15 16H1.5V2.5C1.5 1.94772 1.94772 1.5 2.5 1.5H14C14.5523 1.5 15 1.94772 15 2.5V16Z"
      :fill="color" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#515D65"
    }
  }
}
</script>
